import { COMPONENT_TYPE } from 'common/constants';
import type { BBModel } from 'types/story';
import { createModel } from '../create-model';
import type { CommonCreationContext, CreatedBuildingBlock } from '../creation-types';

export type ImageOptions = Partial<Pick<BBModel['uiConfig']['componentProps'], 'styles' | 'other'>> &
	Partial<CommonCreationContext>;

export const image = ({ styles = {}, other = {} }: ImageOptions = {}): CreatedBuildingBlock<
	typeof COMPONENT_TYPE.IMG
> =>
	createModel({
		type: COMPONENT_TYPE.IMG,
		componentProps: {
			styles,
			other,
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.IMG>;
